import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAppConfigStore } from '@/stores/app-config-store'

export const useDynamicTitle = () => {
  const route = useRoute()
  const appConfigStore = useAppConfigStore()

  const updateTitle = () => {
    try {
      // Extract client segment from URL
      const pathSegments = route.path.split('/')
      const clientSegment = pathSegments[1] // First segment after domain

      let title = 'Labvigator' // Default title

      if (clientSegment && appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP[clientSegment]) {
        const clientData = appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP[clientSegment]

        if (clientData?.clientName) {
          title = `${clientData.clientName} | Labvigator`
        }
      }

      // Update document title
      document.title = title
      console.log('Setting page title:', title)
    } catch (error) {
      console.error('Error updating page title:', error)
      // Fallback to default title
      document.title = 'Labvigator'
    }
  }

  // Watch for route changes
  watch(() => route.path, updateTitle, { immediate: true })

  // Watch for app config changes (when client data is updated)
  watch(() => appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP, updateTitle, { deep: true })

  return {
    updateTitle,
  }
}
